<template>
  <div
    class="main-navigation__drawer"
    :class="{'main-navigation__drawer--is-open': isOpen}"
  >
    <div
      class="main-navigation__backdrop"
      :class="{'main-navigation__backdrop--is-open': isOpen}"
    />
    <div
      class="main-navigation__content"
      :class="{'main-navigation__content--is-open': isOpen}"
    >
      <div class="main-navigation__close">
        <base-icon
          icon="close-x"
          @click="close"
        />
      </div>
      <div class="main-navigation__body">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainNavigationDrawer',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    close() {
      console.log('Close');
      this.isOpen = false;
    },
    open() {
      this.isOpen = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.main-navigation {
  &__drawer {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
     @media (min-width: map-get($breakpoints,'lg')) {
      display: none;
    }

    &--is-open{
        pointer-events: all;
    }
  }
  &__backdrop {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(black, 0.5);
    opacity: 0;
    transition: opacity 0.2s;
    pointer-events: none;

    &--is-open{
        opacity: 1;
        pointer-events: all;
    }
  }
  &__content {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    background-color: white;
    min-width: 622px;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0,0,0.3,1);
    will-change: transform;
    display: flex;
    justify-content:center;
    align-items: center;
    &--is-open{
        transform: translateX(0);
    }
  }
  &__body{
    //   border: solid 1px red;
  }
  &__close {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
}
</style>
